import React from 'react';
import { connect } from 'react-redux';
import { actionCreators } from '../store/ApplicationStore';
import { bindActionCreators } from 'redux';
import config from '../config';

class WindowDimensions extends React.Component {
  _isMounted = false;

  constructor(props) {
    super(props);

    this.state = {
      width: null,
      height: null
    };
  }

  

  componentDidMount() {
    this._isMounted = true;
    window.addEventListener('resize', this.updateDimensions);
    this.updateDimensions();
  }

  componentWillUnmount() {
    this.setState({width:null, height:null})
    this._isMounted = false;
    window.removeEventListener('resize', this.updateDimensions);
  }

  updateDimensions = () => {
    var w = window,
      d = document,
      documentElement = d.documentElement,
      body = d.getElementsByTagName('body')[0],
      width = w.innerWidth || documentElement.clientWidth || body.clientWidth,
      height =
        w.innerHeight || documentElement.clientHeight || body.clientHeight;

        if(width <= config.MobileViewBreakpoint){
          // Is mobile view
          body.classList.add('mobile-mode');
          
          this.props.viewModeChanged(true, { width: width, height: height });
          
          
        }else{
          // Is desktop screen view
          body.classList.remove('mobile-mode');
          
          this.props.viewModeChanged(false, { width: width, height: height });
          
        }
    
      this.setState({ width: width, height: height });
    
  };

  render() {    
    return this.props.render(this.state);
  }
}


export default connect(state => ({ appStore: state.app }), dispatch => bindActionCreators(actionCreators, dispatch))(WindowDimensions);
